import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DndDirective } from './dnd.directive';
import { FileUploadComponent } from './domes-create/file-upload/file-upload.component';
import { VideoUploadComponent } from './domes-create/video-upload/video-upload.component';
import { WebsiteComponent } from './domes-create/website/website.component';
import { InteractiveARComponent } from './domes-create/interactive-ar/interactive-ar.component';
import { VoiceSelectorComponent } from './domes-create/interactive-ar/voice-selector/voice-selector.component';
import { BlogComponent } from './domes-create/blog/blog.component';
import { NavigationComponent } from './domes-create/navigation/navigation.component';
import { MapComponent } from './domes-create/map/map.component';
import { PhoneComponent } from './domes-create/phone/phone.component';
import { CompetitionComponent } from './domes-create/competition/competition.component';
import { JourneyComponent } from './domes-create/journey/journey.component';
import { AppStoreComponent } from './domes-create/app-store/app-store.component';
import { GalleryComponent } from './domes-create/gallery/gallery.component';
import { ColourComponent } from './domes-create/colour/colour.component';
import { LogoComponent } from './domes-create/logo/logo.component';
import { AudioComponent } from './domes-create/audio/audio.component';
import { DomesCreateComponent } from './domes-create/domes-create.component';
import { DomesListComponent } from './domes-list/domes-list.component';
import { ColorPickerModule } from 'primeng/colorpicker';
import { FormatBytesPipe } from '../_pipes/format-bytes.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScenarioDetailsComponent } from './domes-create/interactive-ar/scenario-details/scenario-details.component';
import { ScenarioTreeComponent } from './domes-create/interactive-ar/scenario-tree/scenario-tree.component';
import { InputTextModule } from 'primeng/inputtext';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CallToActionComponent } from './domes-create/call-to-action/call-to-action.component';
import { SharedModule } from '../shared/shared.module';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { TabViewModule } from 'primeng/tabview';
import { DragulaModule } from 'ng2-dragula';
import { EditorModule } from 'primeng/editor';
// DomesCreateModule is removed to break circular dependency
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api'; // Import ConfirmationService
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { SplitButtonModule } from 'primeng/splitbutton';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { CardModule } from 'primeng/card';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MenuModule } from 'primeng/menu'; // Added MenuModule import
import { DomesSharedModule } from './shared/domes-shared.module'; // Import the new shared module

@NgModule({
  declarations: [
    DomesCreateComponent,
    DomesListComponent,
    DndDirective, 
    FileUploadComponent, 
    VideoUploadComponent, 
    WebsiteComponent, 
    InteractiveARComponent, 
    VoiceSelectorComponent, 
    BlogComponent, 
    NavigationComponent, 
    MapComponent, 
    PhoneComponent, 
    CompetitionComponent, 
    JourneyComponent, 
    AppStoreComponent, 
    GalleryComponent, 
    ColourComponent, 
    LogoComponent,
    AudioComponent,
    FormatBytesPipe,
    ScenarioDetailsComponent,
    ScenarioTreeComponent,
    CallToActionComponent
  ],
  
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ButtonModule,
    ColorPickerModule,
    TooltipModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    InputTextModule,
    ButtonModule,
    TabViewModule,
    InputTextareaModule,
    SharedModule,
    QRCodeModule,
    NgxQRCodeModule,
    DragulaModule.forRoot(),
    EditorModule,
    // DomesCreateModule removed
    DynamicDialogModule,
    InputSwitchModule,
    InputNumberModule,
    DialogModule,
    SplitButtonModule,
    FileUploadModule,
    ProgressBarModule,
    CardModule,
    SelectButtonModule,
    MenuModule, // Added MenuModule to imports
    DomesSharedModule // Import DomesSharedModule here
  ],
  exports: [
    DomesCreateComponent,
    DomesListComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [
    DialogService,
    MessageService,
    ConfirmationService // Add ConfirmationService here
  ]
})
export class DomesModule { }
